import { StrategyProps } from './strategies';
import TextField from '../../forms/TextField';
import strings from '../../../strings/strings.json';
import React from 'react';
import Notification, { NotificationType } from '../../notifiers/Notification';
import { FlexColRg } from 'components/Elements';

export default function ImageStrategy({
    localFile,
    localFileValid,
    fileMetaData,
    setFileMetaData,
    setFileMetaDataValid,
}: StrategyProps): JSX.Element {
    const [userHasInteractedWithField, setUserHasInteractedWithField] = React.useState(false);

    React.useEffect(() => {
        setFileMetaData(undefined);
        setUserHasInteractedWithField(false);
    }, [localFile]); // eslint-disable-line

    React.useEffect(() => {
        if (!fileMetaData?.imageAltText) {
            return setFileMetaDataValid(false);
        }
        return setFileMetaDataValid(true);
    }, [fileMetaData]); // eslint-disable-line

    return (
        <>
            {localFileValid && (
                <FlexColRg>
                    <Notification
                        notificationType={NotificationType.INFO}
                        title={strings.fileUpload.imageDescriptionExplanationTitle}
                        maxWidth={'100%'}
                    />
                    <TextField
                        fieldName={strings.fileUpload.imageDescriptionLabel}
                        labelText={strings.fileUpload.imageDescriptionLabel}
                        inputAria={strings.fileUpload.imageDescriptionAria}
                        maxLength={120}
                        errorMessage={
                            userHasInteractedWithField && !fileMetaData?.imageAltText
                                ? strings.fileUpload.imageAltTextRequiredError
                                : undefined
                        }
                        required
                        autoFocus
                        onChange={(event: { target: { value: string } }) => {
                            setFileMetaData({ ...fileMetaData, imageAltText: event.target.value });
                        }}
                        onBlur={() => {
                            setUserHasInteractedWithField(true);
                        }}
                    />
                </FlexColRg>
            )}
        </>
    );
}
